import React, { useState } from 'react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cuánto tiempo tarda en funcionar?',
    a: 'La mayoría de los hombres reporta mejoras notables entre la semana 2 y la semana 4 siguiendo el Plan de 30 Días. Los resultados dependen de la consistencia diaria, pero el sistema está diseñado para dar resultados rápidos y duraderos.'
  }, {
    q: '¿Necesito experiencia o equipamiento especial?',
    a: 'No. El sistema está diseñado para comenzar desde cero. No necesitas ningún equipamiento. Solo 10 minutos al día en cualquier lugar privado. Las instrucciones son paso a paso desde el primer día.'
  }, {
    q: '¿Cómo recibo el producto después de comprar?',
    a: 'Inmediatamente después del pago recibirás un correo con el enlace de descarga y acceso a todos los materiales. Funciona en celular, tablet y computadora. El acceso es instantáneo.'
  }, {
    q: '¿Qué pasa si no veo resultados?',
    a: 'Tenés 30 días de garantía total. Si aplicás el sistema y no ves cambios reales, te devolvemos el 100% de tu dinero sin preguntas. El riesgo es nuestro.'
  }, {
    q: '¿Es discreto? ¿Alguien sabrá que compré esto?',
    a: 'Absolutamente discreto. El cargo en tu tarjeta aparece con un nombre genérico, no relacionado con el producto. Tus datos están 100% protegidos y privados.'
  }, {
    q: '¿Funciona aunque ya haya probado otras cosas sin éxito?',
    a: 'Sí, y especialmente para esos casos. La mayoría de los métodos que existen atacan el síntoma, no la causa. El Código del Control es el único sistema que trabaja simultáneamente el músculo PC (causa física) y la ansiedad del desempeño (causa mental). Por eso funciona cuando lo demás falló.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-[36px] px-5 bg-brand-black" data-id="element-47">
      <div className="max-w-[860px] mx-auto px-5" data-id="element-48">
        <h2 className="font-montserrat font-black text-[clamp(1.5rem,4vw,2.4rem)] text-brand-white uppercase text-center mb-2 leading-[1.15]" data-id="element-49">
          Preguntas <span className="text-brand-red" data-id="element-50">Frecuentes</span>
        </h2>
        <div className="w-[60px] h-[3px] bg-brand-red mx-auto mt-[10px] mb-[22px] rounded-[2px]" data-id="element-51"></div>

        <div className="mt-2.5" data-id="element-52">
          {faqs.map((faq, idx) => <div key={idx} className="border-b border-[#1a1a1a]" data-id="element-53">
              <div className="font-montserrat font-bold text-[0.92rem] text-brand-white uppercase tracking-[0.4px] py-3.5 cursor-pointer flex justify-between items-center gap-2.5" onClick={() => toggleFAQ(idx)} data-id="element-54">
                {faq.q}
                <span className={`text-brand-red text-base shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-90' : ''}`} data-id="element-55">
                  ▶
                </span>
              </div>
              <div className={`text-[0.93rem] text-[#908b83] leading-[1.75] pb-5 ${openIndex === idx ? 'block' : 'hidden'}`} data-id="element-56">
                {faq.a}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}